require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.3@core-js/library/fn/get-iterator.js
// module id = 244
// module chunks = 0